export default {
    category: 'Категория',
    status: 'Состояние',
    project: {
        headers: {
            'settingsTitle':      'Настройки портфеля проектов РЕК',
            'massSettingsTitle':  'Настройки портфеля проектов МАП',
            'title':              'Портфель проектов',
            'posname':            'Название позиции',
            'numeqpos':           'Кол-во',
            'duration':           'Дли-ть (дней)',
            'responsible':        'Ответственный',
            'participants':       'Участники проекта',
            'workinhrnet':        'Работают по HR-сети',
            'approval':           'Согласование',
            'company':            'Компания',
            'icustomer':          'Внутренний заказчик',
            'finalist':           'Фин-ст, на исп.ср., т/у',
            'reqdate':            'Дата запроса',
            'conditions':         'Условия',
            'prjtype':            'Тип проекта',
            'selmethod':          'Способ подбора',
            'status':             'Состояние',
            'closebefore':        'Закрыть до',
            'approvalppls':       'Согласующие',
            'respforcompany':     'Отв. за работу с компанией',
            'feetype':            'Гонорар (тип условий)',
            'feepercent':         'Гонорар (процент)',
            'amount':             'Сумма',
            'foreignlngs':        'Иностранные языки',
            'sex':                'Пол',
            'age':                'Возраст',
            'workplace':          'Рабочее место',
            'schedule':           'График работы',
            'worktype':           'Тип занятости',
            'compdepart':         'Отдел в структуре компании',
            'posdepart':          'Отдел, в котором открыта позиция',
            'probation':          'Исп. срок',
            'classifier':         'Классификатор',
            'town':               'Город',
            'amountmin':          'Оклад Мин.',
            'amountmax':          'Оклад Макс.',
            'feecurrency':        'Валюта гонорара',
            'bonuses':            'Бонусы и соц.пакет',
            'experience':         'Требования к опыту',
            'responsibilities':   'Обязанности',
            'workresps':          'Обязанности',
            'education':          'Образование',
            'personalqual':       'Личные качества',
            'comments':           'Комментарии',
            'subgroup':           'Подгруппа/Группа ответственного',
            'emplofra':           'Сотрудники КА',
            'feeperpos':          'Гонорар на позицию',
            'transprice':         'Трансферная цена',
            'cforesps':           'ЦФО ответственного',
            'cfotoplevel':        'ЦФО верхнего уровня',
            'salary':             'Зарплата',
            'requirements':       'Требования',
            'candidates':         'Кандидаты',
            'workcommit':         'Вышли на работу',
            'result':             'Фин-ст, на исп.ср., т/у',
            'prjstart':           'Начало проекта',
            'negwithclientHR':    'Переговоры с КА',
            'negwithclientKA':    'Переговоры с клиентом',
            'clientcontactpers':  'Контактные лица клиента',
            'feecomments':        'Примечание по гонорару',
            'kad_bdm':            'KAM/BDM',
            'coordinator':        'Координатор',
            'department':         'Отдел',
            'warranty':           'Гарантийный период',
            'actmarketing':       'Активный маркетинг',
            'execdate':           'Дата выполнения',
            'lastchgdate':        'Дата посл.изменения',
            'ancorinfo':          'Информация об АНКОРе',
            'notes':              'Примечание',
            'category':           'Категория',
            'attdocuments':       'Документы, внесенные в карточку',
            'budget':             'Наличие в бюджете',
            'reason':             'Причина возникновения',
            'message':            'Сообщение',
            'ParticipantsWithRole': 'Соисполнители',
            'scenname':           'Сценарий',
            'inworkdate':         'В работе с',
        },
        position: 'Позиция',
        company: 'Компания',
        quantityPosition: 'Кол-во позиций',
        restPosition: 'Осталось позиций',
        city: 'Город',
        department: 'Отдел',
        budget: 'Наличие в бюджете',
        reason: 'Причина возникновения',
        status_project: 'Состояние проекта',
        inworksinse: 'В работе с',
        duration: 'Длительность',
        deadline: 'Закрыть до',
        participants: 'Участники проекта',
        requirements_for_candidate: 'Требования к кандидату',
        experience: 'Стаж',
        education: 'Образование',
        languages: 'Иностранные языки',
        sex: 'Пол',
        age: 'Возраст',
        typeofexperience: 'Стаж',
        personal_qualities: 'Личные качества',
        responsibilities: 'Обязанности',
        workConditions: 'Условия работы',
        salary: 'Оклад',
        bonuses: 'Бонусы',
        probation: 'Испытательный срок',
        days: 'дней',
        workplace: 'Место работы',
        schedule: 'График работы',
        workType: 'Тип занятости',
        work: {
            approval: 'Согласования',
        },
        project_information: 'Карточка проекта',
        additional_information: 'Дополнительная информация',
        conditions: 'Гонорар',
        to_worksheet: 'Перейти к сводке',
        type: 'Тип проекта',
        scenario: 'Сценарий',
    },
};
